import * as React from 'react';
import IconButton from 'src/custom_components/button/icon_button';

import * as social_ph from '../assets/img/icons/product_hunt.png';
import * as social_facebook from '../assets/img/icons/facebook.png';
import * as social_insta from '../assets/img/icons/instagram.png';

class Footer extends React.PureComponent {

    current_year: number = new Date().getFullYear();

    render() {
        return (
            <div className="main-footer main-feature-color main-shadow-top">
                <div className="main-footer-name">Copyright © {this.current_year} OneClick Global, Inc.</div>
                <div className="main-footer-social">
                    <IconButton
                        src={social_facebook} 
                        alt="Facebook Page" 
                        color="#4876ff"
                        className="main-side-spacing"
                        disabled={false}
                        onClick={() => window.location.href = 'https://www.facebook.com/oneclickhrm'}>
                    </IconButton>
                    <IconButton
                        src={social_insta} 
                        alt="Instagram Page" 
                        color="#4876ff"
                        className="main-side-spacing"
                        disabled={false}
                        onClick={() => window.location.href = 'https://www.instagram.com/oneclickhrm'}>
                    </IconButton>
                    <IconButton
                        src={social_ph} 
                        alt="Product Hunt Page" 
                        color="#4876ff"
                        className="main-side-spacing"
                        disabled={false}
                        onClick={() => window.location.href = 'https://www.producthunt.com/posts/oneclick-hrm'}>
                    </IconButton>
                </div>
            </div>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/footer/footer.component.tsx